import * as React from 'react';
import { Res, SaleDTO } from 'core/api';
import { Box, HStack, Text } from '@chakra-ui/react';
import { ThemeManager } from 'pos/ui';

export default function LastSaleBanner({ lastSale }: { lastSale: Nullable<SaleDTO> }) {

	const showLastSale = ThemeManager.isLargeDevice() && lastSale;

	return showLastSale
		? <HStack width={'full'} paddingX={'6'} paddingY={'3'} textAlign={'center'} justifyContent={'space-between'} gap={'20'} borderBottom={'1px solid'} borderColor={'neutral.300'}>
			<Box width={'58'} height={'8'} bg={{ base: '{colors.blue.100}', _dark: '{colors.blue.800}' }} borderRadius={'md'} padding={'0.5'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
				<Box>
					<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.700}', _dark: 'white' }}>{Res.Web.LAST_SALE_CONTROL_LAST_SERIAL_NUMBER_LBL(lastSale.DocumentId, lastSale.SerialNumber.SerieName, lastSale.SerialNumber.Number)}</Text>
				</Box>
			</Box>
			<Box width={'58'} height={'8'} bg={{ base: '{colors.neutral.100}', _dark: '{colors.neutral.800}' }} borderRadius={'md'} padding={'0.5'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
				<Box>
					<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.700}', _dark: 'white' }}>{Res.Web.LAST_SALE_CONTROL_NET_AMOUNT_LBL(lastSale.NetAmount)}</Text>
				</Box>
			</Box>
			<Box width={'58'} height={'8'} bg={{ base: '{colors.neutral.100}', _dark: '{colors.neutral.800}' }} borderRadius={'md'} padding={'0.5'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
				<Box>
					<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.700}', _dark: 'white' }}>{Res.Web.LAST_SALE_CONTROL_PAID_AMOUNT_LBL(lastSale.PaidAmount)}</Text>
				</Box>
			</Box>
			<Box width={'58'} height={'8'} bg={{ base: '{colors.neutral.100}', _dark: '{colors.neutral.800}' }} borderRadius={'md'} padding={'0.5'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
				<Box>
					<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.700}', _dark: 'white' }}>{Res.Web.LAST_SALE_CONTROL_CHANGE_LBL(lastSale.ChangeAmount)}</Text>
				</Box>
			</Box>
		</HStack>
		: null;
}